import styled from 'styled-components';

export const DataGridContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  overflow-x: auto;
`;

export const AvatarBoxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 2
};

export const AvatarStyle = {
  width: 32,
  height: 32
};
